import { post } from "@/util/http";
const COS = require("cos-js-sdk-v5");
import { store } from "@/store/index.js";

export default {
  methods: {
    upload(file) {
      const thirdUploadUrl = store.state.appConfig?.third_upload;
      if (thirdUploadUrl) {
        return this.uploadByThirdParty(file, thirdUploadUrl);
      }
      return this.uploadByCos(file);
    },
    async uploadByThirdParty(file, uploadUrl) {
      try {
        const formData = new FormData();
        formData.append("file", file);
        const response = await fetch(uploadUrl, {
          method: "POST",
          body: formData,
        });
        if (!response.ok) {
          throw new Error(`图片上传失败（${response.status}）`);
        }
        const result = await response.json();
        const imageUrl = result?.data;
        if (!imageUrl) {
          throw new Error(result?.msg || "上传接口未返回图片地址");
        }
        return { status: 0, msg: "上传成功", data: imageUrl };
      } catch (error) {
        return { status: 1, msg: error?.message || "上传失败" };
      }
    },
    uploadByCos(file) {
      console.log(this.getFileNameFormat(file.name), "this.getFileNameFormat(file.name)");
      return new Promise((resolve) => {
        post({ url: "/api/qcloud_sts" })
          .then(async (result) => {
            if (result.status !== 200 || result.data?.status !== 0) {
              resolve({ status: 1, msg: result.data?.msg || "获取上传凭证失败" });
              return;
            }
            const res = result.data;
            // 初始化实例
            const cos = new COS({
              getAuthorization: function (options, callback) {
                const credentials = res.data.Credentials;
                callback({
                  TmpSecretId: credentials.TmpSecretId,
                  TmpSecretKey: credentials.TmpSecretKey,
                  XCosSecurityToken: credentials.Token,
                  ExpiredTime: res.data.ExpiredTime,
                });
              },
              Domain: store.state.appConfig.img_upload_url,
            });

            cos.putObject(
              {
                Bucket: res.data.bucket,
                Region: res.data.region,
                Key: "images/" + res.data.filename + this.getFileNameFormat(file.name),
                Body: file,
              },
              function (err, data) {
                if (err) {
                  resolve({ status: 1, msg: "上传失败" });
                } else {
                  if (data.statusCode === 200) {
                    resolve({ status: 0, msg: "上传成功", data: "https://" + data.Location });
                  } else {
                    resolve({ status: 1, msg: "上传失败" });
                  }
                }
              }
            );
          })
          .catch((error) => {
            resolve({ status: 1, msg: error?.message || "上传失败" });
          });
      });
    },
    getFileNameFormat(filename) {
      const myArray = filename.split(".");
      let formatName = "." + myArray.pop();
      return formatName;
    },
    uploadImgToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader(); //html5提供的一种异步文件读取机制
        reader.readAsDataURL(file); //将文件读取为Base64编码的数据URL
        reader.onload = function () {
          // 图片转base64完成后返回reader对象
          // var array = new Int8Array(reader.result);
          resolve(reader.result);
        };
        reader.onerror = reject;
      });
    },
  },
};
